<template>
  <div>
    <div
      class="d-block subtitle-2 font-weight-bold"
    >
      {{ title }}
    </div>
    <div
      class="d-block"
    >
      <div
        class="d-inline-flex text-center"
      >
        <div
          class="d-block align-self-start text-h4 font-weight-bold"
        >
          {{ integerPart }}
        </div>
        <div
          v-if="useDecimalPoint"
          class="d-block align-self-start text-h5 font-weight-bold pr-1">.</div>
        <div
          v-if="useDecimalPoint"
          class="d-block align-self-start text-h5 font-weight-bold"
        >
          {{ decimalPart }}
        </div>
        <div
          class="d-block align-self-end text-caption font-weight-bold pl-1 pb-2"
        >
          <div
            v-for="(unitTitle, index) in unitTitles"
            :key="index"
            class="summary-unit-title"
          >
            {{ unitTitle }}
          </div>
        </div>
      </div>
    </div>
    <div
      class="d-block"
    >
      <div
        class="align-baseline text-center"
      >
        <div
          :class="['d-inline-block', collapseStyle(valueAll)]"
        >
          <div class="text-caption font-weight-bold">全体</div>
          <div class="d-inline-flex align-baseline text-center">
            <div class="d-block text-h6">{{ displayValue(valueAll) }}</div>
            <div class="text-caption">%</div>
          </div>
        </div>
        <div
          :class="['d-inline-block', 'pl-2', collapseStyle(valueHigh)]"
        >
          <div class="text-caption font-weight-bold">上位</div>
          <div class="d-inline-flex align-baseline text-center">
            <div class="d-block text-h6">{{ displayValue(valueHigh) }}</div>
            <div class="text-caption">%</div>
          </div>
        </div>
        <div
          :class="['d-inline-block', 'pl-2', collapseStyle(valueLow)]"
        >
          <div class="text-caption font-weight-bold">下位</div>
          <div class="d-inline-flex align-baseline text-center">
            <div class="d-block text-h6">{{ displayValue(valueLow) }}</div>
            <div class="text-caption">%</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SummarySingle',
  props: {
    /** カードのタイトル*/
    title: {
      type: String,
      default: null,
    },
    /** 小数点の仕様有無(小数点以下の値の使用有無) */
    useDecimalPoint: {
      type: Boolean,
      default: false,
    },
    /** 単位 */
    unitTitle: {
      type: String,
      default: ''
    },
    /** 自店数値 */
    valueSelf: {
      type: [String, Number],
      default: null,
    },
    /** 全店の値 */
    valueAll: {
      type: [String, Number],
    },
    /** 上位の値 */
    valueHigh: {
      type: [String, Number],
    },
    /** 下位の値 */
    valueLow: {
      type: [String, Number],
    }
  },
  computed: {
    /** 整数部の値 */
    integerPart: function () {
      let integerPart = 0
      if (this.valueSelf === undefined || this.valueSelf === null) {
        return '--'
      }
      if (this.valueSelf > 0) {
        // 正数の場合はMath.floor()を使用
        integerPart = Math.floor(this.valueSelf)
      } else {
        integerPart = Math.ceil(this.valueSelf)
      }
      // カンマ区切りで返す
      return String(integerPart).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
    },
    /** 小数点以下の値 */
    decimalPart: function () {
      let decimalPart = 0
      if (this.valueSelf === undefined || this.valueSelf === null) {
        return '--'
      }
      // 小数点で分割
      let values = String(this.valueSelf).split('.')
      if (values[1]) {
        // 小数点以下がある場合
        decimalPart = values[1]
      }
      return String(decimalPart)
    },
    /** 単位を一文字単位に分割した値 */
    unitTitles: function () {
      let unitTitles = []
      if (this.unitTitle === undefined && this.unitTitle === null) {
        return unitTitles
      }
      unitTitles = String(this.unitTitle).split('')
      return unitTitles
    },
    displayValue: function () {
      return function (value) {
        if (value === undefined || value === null) {
          // undefined or nullは、ハイフン表示
          return '--'
        }
        return value
      }
    },
    collapseStyle: function () {
      return function (value) {
        return (value === undefined) ? 'collapse-style' : ''
      }
    },
  }
}
</script>
<style lang="scss" scoped>
  .summary-unit-title {
    line-height: 0.75rem;
  }
  .collapse-style {
    visibility: collapse;
  }
</style>
